import { CASE_SITUATIONS } from '@/modules/diagnosisModule/services/caseSituations'
import { CASE_CONSULTATIONS } from '@/modules/diagnosisModule/services/caseConsultations'
import { GridUtils } from '@/shared/util/grid-utils'

const getFullTranslationKey = key => `diagnosis.sidebar.${key}`

export default {
    sideBarName: 'DiagnosisSideBar',
    expanded: [
        {
            id: 'cases',
            label: 'diagnosis.sidebar.cases',
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'states',
                    label: 'diagnosis.sidebar.status',
                    hasChildren: true,
                    icon: ['fal', 'tags'],
                    children: [
                        {
                            id: CASE_SITUATIONS.PENDING_GROSSING,
                            label: 'diagnosis.sidebar.pendingGrossing',
                            caseSituation: CASE_SITUATIONS.PENDING_GROSSING,
                            uiComponent: 'uicomponent.diagnosis.filter.pendingGrossing'
                        },
                        {
                            id: CASE_SITUATIONS.PENDING_LABORATORY,
                            label: 'diagnosis.sidebar.pendingLaboratory',
                            caseSituation: CASE_SITUATIONS.PENDING_LABORATORY,
                            uiComponent: 'uicomponent.diagnosis.filter.pendingLaboratory'
                        },
                        {
                            id: CASE_SITUATIONS.PENDING_INFORM,
                            label: 'diagnosis.sidebar.pendingInform',
                            caseSituation: CASE_SITUATIONS.PENDING_INFORM,
                            uiComponent: 'uicomponent.diagnosis.filter.pendingInform'
                        },
                        {
                            id: CASE_SITUATIONS.PENDING_TRANSCRIPTION,
                            label: 'diagnosis.sidebar.pendingTranscription',
                            caseSituation: CASE_SITUATIONS.PENDING_TRANSCRIPTION,
                            uiComponent: 'uicomponent.diagnosis.filter.pendingTranscription'
                        },
                        {
                            id: CASE_SITUATIONS.PENDING_VALIDATION,
                            label: 'diagnosis.sidebar.pendingValidation',
                            caseSituation: CASE_SITUATIONS.PENDING_VALIDATION,
                            uiComponent: 'uicomponent.diagnosis.filter.pendingValidation'
                        },
                        {
                            id: CASE_SITUATIONS.PENDING_ADDITIONAL_ASSAYS,
                            label: 'diagnosis.sidebar.pendingAdditionalAssays',
                            caseSituation: CASE_SITUATIONS.PENDING_ADDITIONAL_ASSAYS,
                            uiComponent: 'uicomponent.diagnosis.filter.pendingAdditionalAssays'
                        },
                        {
                            id: CASE_SITUATIONS.PENDING_COMPLEMENTARY,
                            label: 'diagnosis.sidebar.pendingComplementary',
                            caseSituation: CASE_SITUATIONS.PENDING_COMPLEMENTARY,
                            uiComponent: 'uicomponent.diagnosis.filter.pendingComplementary'
                        },
                        {
                            id: CASE_SITUATIONS.PENDING_AMENDMENT,
                            label: 'diagnosis.sidebar.pendingAmendment',
                            caseSituation: CASE_SITUATIONS.PENDING_AMENDMENT,
                            uiComponent: 'uicomponent.diagnosis.filter.pendingAmendment'
                        }
                    ]
                },
                {
                    id: 'consults',
                    label: 'diagnosis.sidebar.casesWithConsults',
                    hasChildren: true,
                    icon: ['fal', 'comment-alt-dots'],
                    children: [
                        {
                            id: CASE_CONSULTATIONS.CONSULTATION_SENT.code,
                            label: 'diagnosis.sidebar.consultSent',
                            task: CASE_CONSULTATIONS.CONSULTATION_SENT,
                            uiComponent: 'uicomponent.diagnosis.filter.consultSent'
                        },
                        {
                            id: CASE_CONSULTATIONS.CONSULTATION_SENT_SOLVED.code,
                            label: 'diagnosis.sidebar.consultSentSolved',
                            task: CASE_CONSULTATIONS.CONSULTATION_SENT_SOLVED,
                            uiComponent: 'uicomponent.diagnosis.filter.consultSolved'
                        },
                        {
                            id: CASE_CONSULTATIONS.CONSULTATION_RECEIVED.code,
                            label: 'diagnosis.sidebar.consultRec',
                            task: CASE_CONSULTATIONS.CONSULTATION_RECEIVED,
                            uiComponent: 'uicomponent.diagnosis.filter.consultReceived'
                        },
                        {
                            id: CASE_CONSULTATIONS.CONSULTATION_RECEIVED_SOLVED.code,
                            label: 'diagnosis.sidebar.consultRecSolved',
                            task: CASE_CONSULTATIONS.CONSULTATION_RECEIVED_SOLVED,
                            uiComponent: 'uicomponent.diagnosis.filter.consultReceivedSolved'
                        }
                    ]
                }
                // Oculto por petición de Javier hasta nuevo aviso
                /* {
                    id: 'shared',
                    label: 'diagnosis.sidebar.shared',
                    hasChildren: true,
                    icon: ['fal', 'share'],
                    children: [
                        {
                            id: CASE_SITUATIONS.SHARED_BY_ME,
                            label: 'diagnosis.sidebar.sharedByMe',
                            caseSituation: CASE_SITUATIONS.SHARED_BY_ME
                        },
                        {
                            id: CASE_SITUATIONS.SHARED_WITH_ME,
                            label: 'diagnosis.sidebar.sharedWithMe',
                            caseSituation: CASE_SITUATIONS.SHARED_WITH_ME
                        }
                    ]
                }, */
                // Oculto por petición de Javier hasta nuevo aviso
                /* {
                    id: CASE_SITUATIONS.QUALITY,
                    label: 'diagnosis.sidebar.quality',
                    icon: ['fal', 'shield-check'],
                    caseSituation: CASE_SITUATIONS.QUALITY
                } */
            ]
        },
        {
            id: 'validatedCases',
            label: 'diagnosis.sidebar.validatedCases',
            hasChildren: true,
            icon: ['fal', 'calendar-alt'],
            children: [
                {
                    id: 'validatedCasesToday',
                    label: 'diagnosis.sidebar.today',
                    icon: ['fal', 'calendar-day'],
                    caseSituation: CASE_SITUATIONS.VALIDATED,
                    customFilterModel: {
                        casValidationDate: GridUtils.getTodayDateFilterModel()
                    },
                    uiComponent: 'uicomponent.diagnosis.filter.validatedCases'
                },
                {
                    id: 'validatedCasesThisWeek',
                    label: 'diagnosis.sidebar.thisWeek',
                    icon: ['fal', 'calendar-week'],
                    caseSituation: CASE_SITUATIONS.VALIDATED,
                    customFilterModel: {
                        casValidationDate: GridUtils.getThisWeekDateFilterModel()
                    },
                    uiComponent: 'uicomponent.diagnosis.filter.validatedCases'
                },
                {
                    id: 'validatedCasesThisMonth',
                    label: 'diagnosis.sidebar.thisMonth',
                    icon: ['fal', 'calendar-alt'],
                    caseSituation: CASE_SITUATIONS.VALIDATED,
                    customFilterModel: {
                        casValidationDate: GridUtils.getThisMonthDateFilterModel()
                    },
                    uiComponent: 'uicomponent.diagnosis.filter.validatedCases'
                }
            ]
        }
    ],
    module: {
        icon: ['fal', 'file-chart-line'],
        name: getFullTranslationKey('diagnosis')
    }
}
